import { render, staticRenderFns } from "./r-trader-page.vue?vue&type=template&id=b2e02e26"
import script from "./r-trader-page.vue?vue&type=script&lang=js"
export * from "./r-trader-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2e02e26')) {
      api.createRecord('b2e02e26', component.options)
    } else {
      api.reload('b2e02e26', component.options)
    }
    module.hot.accept("./r-trader-page.vue?vue&type=template&id=b2e02e26", function () {
      api.rerender('b2e02e26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-page.vue"
export default component.exports